function getView(viewName, title) {
    return (resolve, reject) => {
        require.ensure([], (require) => {
            let modules = require(`src/views/page/ems/plan/${viewName}`)
            modules.default.options.metaInfo = { title }
            resolve(modules)
        }, reject, 'plan')
    }
}

let routes = [
    {
        name: 'planReport',
        path: '/ems/planReport',
        meta: {
            title: '计划与报告'
        }
    },
    {
        name: 'planList',
        path: '/ems/planList',
        meta: {
            title: '计划列表'
        }
    },
    {
        name: 'planDetail',
        path: '/ems/planDetail',
        meta: {
            title: '计划详情'
        }
    },
    {
        name: 'addPlan',
        path: '/ems/addPlan',
        meta: {
            title: '添加计划'
        }
    },
    {
        name: 'addSuccess',
        path: '/ems/addSuccess',
        meta: {
            title: '维保计划'
        }
    },
    {
        name: 'maintenanceProject',
        path: '/ems/maintenanceProject',
        meta: {
            title: '维保中项目'
        }
    },
    {
        name: 'currentPlanDetail',
        path: '/ems/currentPlanDetail',
        meta: {
            title: '计划详情'
        }
    }
]

routes.forEach((v) => {
    if (!v.redirect && !v.component) {
        v.component = getView(v.name, v.meta.title)
    }
})

export default routes



// WEBPACK FOOTER //
// ./src/router/modules/ems/plan.js